<template>
  <div
    class="card mb-2"
    :class="[
      {
        'border-dark border-3': isCurrentTopic(topic)
      }
    ]"
  >
    <div
      class="
        card-header
        fw-bold
        d-flex
        justify-content-between
        align-items-center
        btn
        text-start
      "
      @click="toggleOpen"
    >
      <span>{{ topic }}</span>
      <span :class="isOpen ? 'icon-open' : 'icon-closed'">{{
        isOpen ? "▼" : "▶"
      }}</span>
    </div>
    <div v-if="isOpen" class="card-body">
      <div v-for="question in questionsForTopic(topic)" :key="question.uuid">
        <button
          :class="[
            'btn',
            'my-1',
            'w-100',
            'text-start',
            {
              'bg-orange-beaver': isCurrentQuestion(question),
              'btn-light': !isCurrentQuestion(question)
            }
          ]"
          @click="selectQuestion(question)"
        >
          <span class="d-flex justify-content-between">
            <span>{{ question.questionText }}</span>
            <span v-if="isQuestionAnswered(question)" class="checkmark text-end"
              >✔️</span
            >
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "TopicCard",
  components: {},
  data() {
    return {
      isOpen: false
    };
  },
  props: {
    topic: {
      type: String,
      default: () => {
        return "";
      }
    },
    questions: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed: {
    ...mapGetters(["getCurrentQuestion", "getSurveyAnswers"])
  },
  methods: {
    ...mapActions(["setCurrentQuestion", "setSurveyComplete"]),
    toggleOpen() {
      this.isOpen = !this.isOpen;
      this.setQuestionToFirstQuestionOfThatTopic();
    },
    setQuestionToFirstQuestionOfThatTopic() {
      const firstQuestion = this.questionsForTopic(this.topic)[0];
      if (firstQuestion) {
        this.setCurrentQuestion(firstQuestion);
      }
    },
    toggleStayOpen() {
      this.isOpen = true;
    },
    toggleStayClosed() {
      this.isOpen = false;
    },
    questionsForTopic(topic) {
      return this.questions.filter((question) => question.topic === topic);
    },
    selectQuestion(question) {
      this.setCurrentQuestion(question);
    },
    isQuestionAnswered(question) {
      return this.getSurveyAnswers.some(
        (answer) => answer.questionUUID === question.uuid
      );
    },
    isCurrentQuestion(question) {
      return this.getCurrentQuestion?.uuid === question.uuid;
    },
    isCurrentTopic(topic) {
      return this.getCurrentQuestion?.topic === topic;
    }
  },
  watch: {
    getCurrentQuestion: {
      handler(newVal) {
        if (newVal && newVal.topic) {
          this.setSurveyComplete(false);
          if (this.topic === newVal?.topic) {
            this.toggleStayOpen();
          } else {
            this.toggleStayClosed();
          }
        } else {
          this.setCurrentQuestion("Summary");
          this.setSurveyComplete(true);
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.checkmark {
  color: green;
  margin-left: 10px;
}

.bg-orange-beaver {
  background-color: #d7400989;
}
</style>
